import { render, staticRenderFns } from "./LinkWithApisOrders.vue?vue&type=template&id=5b457f0a&scoped=true"
import script from "./LinkWithApisOrders.vue?vue&type=script&lang=js"
export * from "./LinkWithApisOrders.vue?vue&type=script&lang=js"
import style0 from "./LinkWithApisOrders.vue?vue&type=style&index=0&id=5b457f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b457f0a",
  null
  
)

export default component.exports